package com.advaita.cloud.drive.ui.components

/**
 * Byte-size formatting shared by the file table and the preview pane.
 *
 * Extracted from FileTable when the preview footer needed the same output
 * (ADV-1200) — two copies would have drifted, and the size a row shows must
 * match the size the pane shows for the same file.
 */
internal fun formatSize(bytes: Long?): String {
    if (bytes == null) return "—"
    return when {
        bytes >= 1_073_741_824L -> "${roundOne(bytes / 1_073_741_824.0)} GB"
        bytes >= 1_048_576L -> "${roundOne(bytes / 1_048_576.0)} MB"
        bytes >= 1_024L -> "${roundOne(bytes / 1_024.0)} KB"
        else -> "$bytes B"
    }
}

internal fun roundOne(value: Double): String {
    val rounded = kotlin.math.round(value * 10.0) / 10.0
    val intPart = rounded.toLong()
    val fracPart = kotlin.math.round((rounded - intPart) * 10).toLong()
    return "$intPart.$fracPart"
}
